import React, { useState, useEffect } from "react";
import "./agent.scss";
import AgentHeader from "../../components/header/AgentHeader";
import { useNavigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetAgentInfo } from "../../hooks/useGetAgentInfo";
import { useGetFuelRequests } from "../../hooks/useGetFuelRequests";
import { useFuelRequestsStore } from "../../store/fuelRequestStore";
import AnalyticsListener from "../AnalyticsListener";

export default function AgentPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [responseInfo, setResponseInfo] = useState({
    info: {},
  });

  const { setFuelRequestsData } = useFuelRequestsStore();

  const {
    isPending: isInfoPending,
    isSuccess: isInfoSuccess,
    error: infoError,
    data: infoData,
  } = useGetAgentInfo();

  useEffect(() => {
    if (infoError) {
      navigate("/error", {
        state: {
          code: infoError.code,
          message: infoError.message,
        },
      });
    }
  }, [infoError, navigate]);

  useEffect(() => {
    if (isInfoSuccess) {
      setResponseInfo(infoData);
    }
  }, [isInfoSuccess, infoData]);

  const { chatUrl, nick } = responseInfo;
  const uplinkAgent = infoData?.uplinkAgent;

  const formatDate = (date) => date.toISOString().split("T")[0];
  const today = new Date();
  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(today.getDate() - 3);

  const status =
    uplinkAgent === undefined
      ? null
      : uplinkAgent === null
      ? ["NEW"]
      : ["NEW", "APPROVED", "CANCELED"];

  const {
    data: requestsData,
    isPending: isRequestsPending,
    isSuccess: isRequestsSuccess,
    error: requestsError,
  } = useGetFuelRequests(
    {
      startDate: formatDate(threeDaysAgo),
      endDate: formatDate(today),
      status,
    },
    {
      enabled: status !== null,
    }
  );

  useEffect(() => {
    if (requestsError) {
      navigate("/error", {
        state: {
          code: requestsError.code,
          message: requestsError.message,
        },
      });
    }
  }, [requestsError, navigate]);

  useEffect(() => {
    if (isRequestsSuccess) {
      setFuelRequestsData(requestsData);
    }
  }, [isRequestsSuccess, requestsData, setFuelRequestsData]);

  useEffect(() => {
    document.title = t("documentTitle");
  }, [i18n.language, t]);

  return (
    <>
      <AgentHeader />
      <AnalyticsListener/>
      <Outlet
        context={{
          responseInfo,
          isInfoPending,
          isRequestsPending,
          chatUrl,
          uplinkAgent,
          nick,
        }}
      />
    </>
  );
}
